import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ManifestService } from 'src/app/services/operations/manifest.service';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { CheckboxCellComponent } from 'src/app/components/shared/ag-grid/cell-renderers/checkbox-cell.component';
import printJS from 'print-js-updated';
import { lastValueFrom } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PickupService } from 'src/app/services/operations/pickup.service';
import { CustomerService } from 'src/app/services/customer.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BagPrintComponent } from '../bag-print/bag-print.component';
import { saveAs } from 'file-saver';
import { Title } from '@angular/platform-browser';
import { UpdateStatusComponent } from '../update-status/update-status.component';
import { ExcelService } from 'src/app/services/excel.service';


@Component({
  selector: 'app-listmanifest',
  templateUrl: './listmanifest.component.html',
  styleUrls: ['./listmanifest.component.scss']
})
export class ListManifestComponent implements OnInit, AfterViewInit {
  manifestList = [];
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isActionAllowed = true;
  public isCollapsed = true;
  userType: string;
  filterForm!: FormGroup;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    flex: 1,
    sortable: true,
    resizable: false,
    filterParams: {
      popupParent: document.body,  // Moves filter popup outside the grid container
    },
  };
  defaultServiceCenterId: any;
  gridOptions: GridOptions;
  columnDefs = [
    { headerName: 'Manifest No.', field: 'manifestfullno', filter: true },
    {
      headerName: 'Date',
      field: 'manifestdate',
      maxWidth: 150,
      filter: 'agDateColumnFilter',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        if (!valueA || !valueB) return 0; // Handle empty values

        const [dayA, monthA, yearA] = valueA.split('-').map(Number);
        const [dayB, monthB, yearB] = valueB.split('-').map(Number);

        return new Date(yearA, monthA - 1, dayA).getTime() - new Date(yearB, monthB - 1, dayB).getTime();
      },
      filterParams: {
        comparator: (filterDate: Date, cellValue: string) => {
          if (!cellValue) return 0;

          const [day, month, year] = cellValue.split('-').map(Number);
          const cellDate = new Date(year, month - 1, day).setHours(0, 0, 0, 0); // Normalize to start of day
          const filterTime = filterDate.setHours(0, 0, 0, 0); // Normalize to start of day

          if (cellDate < filterTime) return -1;
          if (cellDate > filterTime) return 1;
          return 0;
        },
        browserDatePicker: true,
        defaultOption: 'inRange',
        suppressAndOrCondition: true,
        suppressFilterButton: false,
        buttons: ['reset'],
        inRangeInclusive: true, // Ensures the 'to' date is included
      }
    },
    { headerName: 'Manifested To', field: 'manifestfor', filter: true },
    { headerName: 'From', field: 'fromservicecenter', filter: true },
    { headerName: 'To', field: 'toservicecenter', filter: true },
    { headerName: 'Vendor', field: 'vendorname' },
    {
      headerName: 'Ready to dispatch', field: 'isclosed',
      cellRenderer: CheckboxCellComponent, maxWidth: 140
    },
    {
      headerName: 'Status',
      field: 'transactionstatus',
      width: 110,
      pinned: 'right',
      cellRenderer: (params: { value: string; }) => {
        let statusHtml = `<span class="badge bg-light">${params.value}</span>`;
        if (params.value === 'MANIFEST_CREATED') {
          statusHtml = `<span class="badge bg-light">CREATED</span>`;
        } else if (params.value === 'MANIFEST_RECEIVED') {
          statusHtml = `<span class="badge bg-primary">RECEIVED</span>`;
        } else if (params.value === 'MANIFEST_PARTIALLY_RECEIVED') {
          statusHtml = `<span class="badge bg-primary">PARTIALLY RECEIVED</span>`;
        } else if (params.value === 'MANIFEST_FINALIZED') {
          statusHtml = `<span class="badge bg-success">FINALIZED</span>`;
        } else {
          statusHtml = `<span class="badge bg-dark">${params.value ? (params.value.split('_')[1] || params.value) : ''}</span>`;
        }
        return statusHtml;
      }
    },
    {
      headerName: 'Actions',
      field: 'isclosed',
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      pinned: 'right',
      width: 150,
    },
  ];
  rowData = [];
  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private manifestsService: ManifestService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private pickupService: PickupService,
    private customerService: CustomerService,
    private titleService: Title,
    private excelService: ExcelService,
  ) {
    titleService.setTitle('Manifest');
    this.context =
    {
      componentParent: this,
      componentName: 'ListManifestComponent',
      printFor: 'manifest',
      actionConfig: { delete: true, edit: true, inboundAction: true, printAction: true, zipAction: true, more: true, updateStatus: true }
    };

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 20,
      domLayout: 'autoHeight'
    };
  }
  selectedSCId: number;
  customerid: number;

  ngOnInit(): void {
    this.filterForm = this.fb.group({
      customerCheck: [false],
      inboundCheck: [false],
      outboundCheck: [false]
    });
    this.checkPermission();

    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
        // console.log('this.selectedSCId', this.selectedSCId);
        this.filterManifest();
      });
    }
    this.handleSingleSelection();
  }

  ngAfterViewInit(): void {
    // this.bindManifestList(this.userType);
  }

  handleSingleSelection() {
    Object.keys(this.filterForm.controls).forEach(controlName => {
      this.filterForm.get(controlName)?.valueChanges.subscribe(value => {
        if (value) {
          Object.keys(this.filterForm.controls).forEach(otherControlName => {
            if (otherControlName !== controlName) {
              this.filterForm.get(otherControlName)?.setValue(false, { emitEvent: false });
            }
          });
        }
      });
    });
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.userType = userData.accessType;
    this.customerid = userData.metaInfo?.customerid;
    const permission = userData.config.filter(x => x.categoryname === 'Manifests');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  onCheckBoxChange(event: any) {
    if (event.checked) {
      const obj = {
        manifestid: event.rowdata.id,
        status: 'finalize',
        generatedfromid: this.selectedSCId
      }
      this.ngxLoaderService.start();
      this.manifestsService.updateStatus(obj).subscribe(res => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.bindManifestList(this.userType);
          this.appCoreService.showMessage('Manifest Finalized');
          if (this.userType === 'Customer')
            this.generatePickupConfirmation(this.customerid);

        } else if (res && !res?.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage('API processing Error', '', 'error');
        }
      });
    } else {
      this.appCoreService.showMessage('Cannot Inactivate. At least One record should be active', '', 'error');
    }
  }

  async filterManifest() {
    try { 
      this.bindManifestList(this.userType, this.filterForm.get('customerCheck').value ? 'Customer' : null);
    } catch (error) {
      this.ngxLoaderService.stop();
    }
  }


  bindManifestList(usertype, generatedby?: string, refresh = false) {
    try {
 
      let inboundCheck = this.filterForm.get('inboundCheck').value;
      let outboundCheck = this.filterForm.get('outboundCheck').value;

      this.ngxLoaderService.start();
      this.manifestsService.GetAll({
        scid: this.selectedSCId,
        usertype: usertype,
        generatedby: generatedby,
        inboundcheck : inboundCheck,
        outboundcheck : outboundCheck,
        refresh: refresh
      }).subscribe(res => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;
          // console.log('rowData', this.rowData);
        } else {
          this.ngxLoaderService.stop();
        }
      });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  ngOnDestroy(): void {

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errAlert('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/operation/manifests/edit', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }

  }

  editInboud(cell: any) {
    if (!this.permConfig.isEditAllowed) {
      this.errAlert('No Access to Edit.');
    }
    else if (cell && cell.id) {
      const serviceURL = `/operation/manifests/${cell.id}/inbound`;
      this.router.navigate([serviceURL]);
    }

  }

  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.errAlert('No Access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      const result = await this.openConfirmationDialog('Are you sure you want to delete ?');
      if (result) {
        this.deleteRecord(cell.id);
      }
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.manifestsService.DeleteById(id).subscribe((res) => {
          if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record deleted successfully', 'Success', 'success');
            this.bindManifestList(this.userType, null,true);
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
      this.appCoreService.showMessage('API Error', 'Error', 'error');
    }
  }

  async printPDF(manifestNumber, printType: string, ) {
    let inputParams = {
      manifestNumber,
      type: printType
    }
    if (inputParams.type == 'bag') {
      let ngbModalOptions: NgbModalOptions = {
        ariaLabelledBy: 'modal-basic-title',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        centered: true,
      }
      const modalRef = this.modalService.open(BagPrintComponent, ngbModalOptions);
      modalRef.componentInstance.manifestNumber = inputParams.manifestNumber;
      modalRef.result.then(
        (result) => {
          // console.log("Result", result);
        }
      );
    } else if (inputParams.type == 'manifest') {
      let inputParams = {
        manifestNumber: manifestNumber,
        type: 'manifest'
      }
      this.ngxLoaderService.start();
      this.manifestsService.GeneratePDF(inputParams).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          // console.log("pdf generated for :-", res);
          let pdfString = JSON.parse(res.data);
          printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
        }

      });
    } else if (printType === 'exportcsv') {
      this.ngxLoaderService.start();
      const res = await lastValueFrom(this.manifestsService.GetAwbDetailsForExcelById(manifestNumber));
      if(res){
        this.ngxLoaderService.stop();
        const awbdetails = res.data?.manifestdetails;
        const manifestNo = res.data?.manifestno;
        const manifestDate = res.data?.manifestdate?.split(' ')[0];
        const name = manifestNo?.replace(/\//g, "_");

        // Format CSV with correct column order
        const formattedRows = awbdetails.map((row, index) => ({
          'srno': index + 1,  // Auto-incremented serial number
          'Manifest Date': manifestDate?.trim() || '',
          'AwbNo': row.awbnumber?.trim() || '',
          'Content': row.contents?.trim() || '',
          'Actual Weight': parseFloat(row.weight || '0').toFixed(3),
          'Pcs': row.pieces || '',
          'Shipper Name': row.shippername?.trim() || '',
          'Shipper TelNo': row.shippertel?.trim() || '',
          'Shipper Add1': row.shipperaddress1?.trim() || '',
          'Origin': row.origin?.trim() || '',
          'Origin Code': row.origincode?.trim() || '', 
          'Orgin Country': row.origincountry?.trim() || '',
          'consignee name': row.consigneename?.trim() || '',
          'Consignee TelNo': row.consigneetel?.trim() || '',
          'consignee add1': row.consigneeaddress1?.trim() || '',
          'consignee add2': row.consigneeaddress2?.trim() || '',
          'Destination': row.destination?.trim() || '',
          'Destination code': row.destinationcode?.trim() || '',
          'Keydate2': row.bookingdate?.split('T')[0]?.trim() || '',
          'Vendor Code': row.vendorcode?.trim() || '',
          'Product': row.product?.trim() || '',
        }));
        // console.log(formattedDRSRows); // Check if columns are correct
        this.excelService.exportAsCSVFile(formattedRows, name, true);
      }
    } 
  }

  async openConfirmationDialog(msg: any): Promise<boolean> {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
    return false;
  }

  errAlert(msg: any) {
    Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      text: msg,
    });
  }

  formateDate(datetime: any): string {
    try {
      const timestamp = new Date(datetime);
      const year = timestamp.getFullYear();
      const month = (timestamp.getMonth() + 1).toString().padStart(2, '0');
      const day = timestamp.getDate().toString().padStart(2, '0');
      return `${day}-${month}-${year}`;
    } catch (e) {
      console.error('Error occurred during date parsing:', e);
      return '';
    }
  }

  async generatePickupConfirmation(customerid: any) {
    const result = await Swal.fire({
      titleText: '',
      text: 'Do you want to generate Pickup?',
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    if (result.isConfirmed) {
      this.customerService.GetById(customerid, { type: "Pickup" }).subscribe((res) => {
        if (res && res.success) {
          // console.log('customer-details', res.data[0]);

          this.generatePickup(res.data[0]);
        }
      });
    }
  }

  async generatePickup(customerdetails: any) {
    try {
      const requestObj = {
        pickupNo: null,
        customerid: customerdetails?.id,
        pickupdate: new Date().toISOString(),
        // mobile: pickupForm.get('txtMobile').value,
        contactperson: customerdetails?.contactperson,
        details: [{
          update: 'Yes',
          info: {
            id: customerdetails?.id || null,
            code: customerdetails?.code || null,
            name: customerdetails?.name || null,
            type: 'Shipper',
            location: customerdetails?.details || null
          },
        }],
        servicecenterid: this.selectedSCId
      }
      // console.log('requestObj',requestObj);

      this.ngxLoaderService.start();
      this.pickupService.Add(requestObj).subscribe((res) => {
        try {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Pickup generated successfully.', 'Success', 'success');
          }
        }
        catch (err) {
          this.ngxLoaderService.stop();
          console.error(err);
        }
      });
    } catch (error) {

    }
  }

  zipFile(manifestnumber: string) {
    try {
      this.ngxLoaderService.start();
      this.manifestsService.GenerateZIP({ manifestNumber: manifestnumber }).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          const uint8Array = new Uint8Array(res?.data[0]?.data ?? res?.data[0]);
          const zipBlob = new Blob([uint8Array], { type: 'application/zip' });
          saveAs(zipBlob, `manifest${manifestnumber}.zip`);
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage(res?.error?.message ?? 'Internal Server Error', 'Error', 'error');
        }
      })
    } catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }

  updateStatus(cell:any) {
      let ngbModalOptions: NgbModalOptions = {
        ariaLabelledBy: 'modal-basic-title',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        centered: true
      };
      const modalRef = this.modalService.open(UpdateStatusComponent, ngbModalOptions);
      modalRef.componentInstance.cellData = cell;
      modalRef.result.then(
        (result) => {
          if (result) {
            /* after closing modal */
          }
        },
        (reason) => {
          //on close awb Dialog do nothing
        }
      );
    }
}
